import React from "react"

import Style from "./style"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const TextModal = () => {

    const [label, , resetState] = useAlertModalAtom()

    return (
        <DefaultModal closeEvent={resetState} upper>
            <Style.Label>{label}</ Style.Label>
            <DefaultButton clickEvent={resetState} small>확인</DefaultButton>
        </DefaultModal>
    )
}

export default TextModal